import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Select2OptionData } from 'ng-select2';
import { PitstopModel } from '../models/pitstop';
import { GsDistributorAddressDTO } from '../models/common';


@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private pathAPI = environment.urlAPI;
  private controller = "Shared/";

  constructor(private http: HttpClient) { }

  public GetProvince(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraProvince');
  }

  public GetCupraModel(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraModel');
  }

  public GetCupraModelVersion(idModel: number): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraModelVersion/' + idModel);
  }

  public GetCupraCalculatorOperation(idLoad: string): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraCalculatorOperation/' + idLoad);
  }

  public GetPiezaDesgaste(idLoad: string): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetPiezaDesgaste/' + idLoad);
  }

  public GetPiezaDesgasteOption(idPieza: number): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetPiezaDesgasteOption/' + idPieza);
  }

  public GetCupraCalculatorPitstop(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraCalculatorPitstop');
  }

  public GetCupraCalculatorConfigurationType(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraCalculatorConfigurationType');
  }

  public GetCupraCalculatorConfigurationCalculatedType(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraCalculatorConfigurationCalculatedType');
  }

  public GetCupraModelVersionMotorType(): Observable<Array<Select2OptionData>> {
    return this.http.get<Array<Select2OptionData>>(this.pathAPI + this.controller + 'GetCupraModelVersionMotorType');
  }

  public getCupraCalculatorConfigurationPitstop(): Observable<PitstopModel[]> {
    return this.http.get<PitstopModel[]>(this.pathAPI + this.controller + 'GetCupraCalculatorConfigurationPitstop');
  }

  public GetCupraDistributorByProvince(IdProvince): Observable<GsDistributorAddressDTO[]> {
    return this.http.get<GsDistributorAddressDTO[]>(this.pathAPI + this.controller + 'GetCupraDistributorByProvince/' + IdProvince);
  }
}
